import { Datasource } from "../models/Datasource";
import client from "./axios";

const datasourcesUrl = `${window.__env.GATEWAY_URL}/v1/datasources`;

export const Datasources = {
  getDatasources: (params?: URLSearchParams) => client.get<Datasource[]>(datasourcesUrl, { params }),
  getDatasource: (id: number) => client.get<Datasource>(`${datasourcesUrl}/${id}`),
  createDatasource: (datasource: Datasource) => client.post<Datasource>(datasourcesUrl, datasource),
  updateDatasource: (datasource: Datasource) => client.put<Datasource>(`${datasourcesUrl}/${datasource.id}`, datasource),
  deleteDatasource: (id: number) => client.delete(`${datasourcesUrl}/${id}`),
  bulkDelete: (params?: URLSearchParams) => client.delete(`${datasourcesUrl}/bulkDelete`, { params }),
}